export default {
  "content": "<path d=\"M14.59 2.59A2 2 0 0013.17 2H6a2 2 0 00-2 2v16a2 2 0 001.99 2H18a2 2 0 002-2V8.83c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM15 18H9a1 1 0 01-1-1 1 1 0 011-1h6a1 1 0 011 1 1 1 0 01-1 1zm0-4H9a1 1 0 01-1-1 1 1 0 011-1h6a1 1 0 011 1 1 1 0 01-1 1zm-2-6V3.5L18.5 9H14a1 1 0 01-1-1z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#333",
    "viewBox": "0 0 24 24"
  }
};